import { AppForms, navigation } from '@/config'
import { APIClient } from '@/services'
import { Button, Checkbox, Text, TextInput, View, AuthFormComponents } from '@/components'
import { useKeydown } from '@codeleap/web'
import { useLingui } from '@lingui/react/macro'

export const LoginForm = () => {
  const { t } = useLingui()

  const onSuccess = () => {
    navigation.navigate('Home')
  }

  const handleSocial = APIClient.Session.useSocialLogin((userSocial) => {
    if (userSocial) {
      onSuccess()
    }
  }, 'login')

  const isValid = AppForms.login.use(f => f.isValid)

  const login = APIClient.Session.useLogin()

  const handleSubmit = async () => {
    try {
      const { email, password } = AppForms.login.values

      const successLogin = await login(email, password)

      if (successLogin) {
        onSuccess()
      }
    } catch (e) {
      logger.error(e)
    }
  }

  useKeydown('Enter', () => {
    const isInvalidSubmit = !isValid
    if (isInvalidSubmit) return
    handleSubmit?.()
  }, [isValid])

  return (
    <View style={['column', 'fullWidth']}>
      <Text style={['h1', 'extraBold', 'marginBottom:1']} text={t`Welcome back`} />
      <Text style={['p1', 'marginBottom:4']} text={t`Login to your account now`} />

      <View style={['flex', 'column', 'gap:4', 'fullWidth']}>
        <View style={['column', 'fullWidth']}>
          <TextInput
            {...AppForms.login.register('email')}
            leftIcon={{ name: 'mail' }}
          />
          <TextInput
            {...AppForms.login.register('password')}
            leftIcon={{ name: 'key' }}
            visibilityToggle
          />
          <Checkbox
            {...AppForms.login.register('remember')}
            style={['left']}
          />
        </View>

        <AuthFormComponents.SocialProviders onPress={handleSocial} />

        <View style={['column', 'gap:2']}>
          <Button
            onPress={handleSubmit}
            disabled={!isValid}
            debugName={`submit Login`}
            text={t`Continue`}
            style={['marginHorizontal:auto', 'fullWidth', 'large', !isValid && 'outline']}
          />

          <Button
            onPress={() => navigation.navigate('Auth.ForgotPassword')}
            debugName={'navigate to forgot password Button'}
            style={['outline', 'large', 'row', 'gap:1', 'alignCenter', 'justifyCenter', 'paddingHorizontal:2']}
          >
            <Text text={t`Forgot password?`} style={['medium', 'alignSelfCenter', 'row', 'color:neutralSolid1000']} />
          </Button>
        </View>
      </View>

      <AuthFormComponents.RedirectLink
        route={'Auth.Signup'}
        text={t`Don't have an account?`}
        textAction={t`Sign up`}
      />
    </View>
  )
}
